import { render, staticRenderFns } from "./wtVideoPosterToggle.vue?vue&type=template&id=37bddd57&scoped=true&"
import script from "./wtVideoPosterToggle.vue?vue&type=script&lang=js&"
export * from "./wtVideoPosterToggle.vue?vue&type=script&lang=js&"
import style0 from "./wtVideoPosterToggle.vue?vue&type=style&index=0&id=37bddd57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bddd57",
  null
  
)

export default component.exports